module.exports = __webpack_public_path__ + "img/Mission.712280bd.png";